export default __webpack_public_path__ + "static/s3-268d94c35342f21d5a1fd1ea265ed369.jpg";